<template>
  <div>
    <Header />
    <section class="section-b-space">
     <div>
         
        <h3>Subscription Plan </h3>
       <v-card height="600" class="mt-4" style=" background-color:#FFFFFF;">
         <b-row class="pl-4 pt-3">
            
          <b-col md="3">
            <div>
                 <v-hover v-slot="{ hover }" close-delay="200">
              <v-card :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }" height="480" width="260">
                <div class="pricing-card">
                  <h3 class="pricing-card-header">Subscription plan -1 </h3>
                  <div class="price mt-3"><sup>₹ </sup>121<span>/Month</span></div>
                  <p class="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                  <ul class="mt-4">
                    <li>Ultimate Features</li>
                    <hr>
                    <li> Responsive Ready</li>
                    <hr>
                    <li> Visual Composer Included</li>
                    <hr>
                    <li> 24/7 Support System</li>
                    <hr>
                    <li> Limited cloud access</li>
                  </ul>
                  <button type="button" class="btn order-btn  btn-primary mt-3">
                    Subscribe Now
                  </button>
                </div>
              </v-card>
                 </v-hover>
            </div>
          </b-col>
           <b-col md="3">
            <div>
                 <v-hover v-slot="{ hover }" close-delay="200">
              <v-card :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }" height="480" width="260">
                <div class="pricing-card">
                  <h3 class="pricing-card-header" style="background-color:#FF6B98;">Subscription plan -2</h3>
                  <div class="price mt-3" style="color:#FF6B98;"><sup>₹ </sup>151<span>/Month</span></div>
                  <p class="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                  <ul class="mt-4">
                    <li> Ultimate Features</li>
                    <hr>
                    <li> Responsive Ready</li>
                    <hr>
                    <li> Visual Composer Included</li>
                    <hr>
                    <li> 24/7 Support System</li>
                    <hr>
                    <li> Limited cloud access</li>
                  </ul>
                  <button type="button" style="background-color:#FF6B98; color:white;" class="btn order-btn   mt-3">
                    Subscribe Now
                  </button>
                </div>
              </v-card>
                 </v-hover>
            </div>
          </b-col>
           <b-col md="3">
            <div>
                 <v-hover v-slot="{ hover }" close-delay="200">
              <v-card :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }" height="480" width="260">
                <div class="pricing-card">
                  <h3 class="pricing-card-header" style="background-color:#5EBBFF;">Subscription plan -3</h3>
                  <div class="price mt-3" style="color:#5EBBFF;"><sup>₹ </sup>501<span>/Month</span></div>
                  <p class="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                  <ul class="mt-4">
                    <li> Ultimate Features</li>
                    <hr>
                    <li> Responsive Ready</li>
                    <hr>
                    <li> Visual Composer Included</li>
                    <hr>
                    <li> 24/7 Support System</li>
                    <hr>
                    <li> Limited cloud access</li>
                  </ul>
                  <button type="button" style="background-color:#5EBBFF; color:white;" class="btn order-btn  mt-3">
                    Subscribe Now
                  </button>
                </div>
              </v-card>
                 </v-hover>
            </div>
          </b-col>
           <b-col md="3">
            <div>
                 <v-hover v-slot="{ hover }" close-delay="200">
              <v-card :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }" height="480" width="260">
                <div class="pricing-card">
                  <h3 class="pricing-card-header" style="background-color:#FFA724;">Subscription plan -4</h3>
                  <div class="price mt-3" style="color:#FFA724;"><sup>₹ </sup>551<span>/Month</span></div>
                  <p class="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                  <ul class="mt-4">
                    <li> Ultimate Features</li>
                    <hr>
                    <li> Responsive Ready</li>
                    <hr>
                    <li> Visual Composer Included</li>
                    <hr>
                    <li> 24/7 Support System</li>
                    <hr>
                    <li> Limited cloud access</li>
                  </ul>
                  <button type="button" style="background-color:#FFA724; color:white;" class="btn order-btn  mt-3">
                    Subscribe Now
                  </button>
                </div>
              </v-card>
                 </v-hover>
            </div>
          </b-col>
        </b-row>
      </v-card>
       
      </div>
      
    </section>
    <Footer class="mt-5" />
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import { getReverseGeoCode } from "@/services/geocode";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      langObj: {
        en: "English",
        bn: "Bengali",
        te: "Telugu"
      },
      lightMode: true,
      enableManufacturer: false,
      paramsId: null,
      isEditMode: false,
      oldPwd: "",
      newPwd: "",
      cfmPwd: "",
      errorMessages: "",
      details: {
        name: "",
        phone: "",
        email: ""
      },
      hasAddress: false,
      address: {
        city: "",
        country: "",
        houseNumber: "",
        state: "",
        street1: "",
        zip: "",
        location: {
          coordinates: [0, 0]
        }
      },
      selectedLanguage: [],
      defaultLanguage: "",
      languages: [
        { id: "en", name: "English" },
        { id: "bn", name: "Bengali" },
        { id: "te", name: "Telugu" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "profileUpdate/GetmeTenant",
      tenantLanguage: "tenant/GetTenantLanguage",
      tenantPreferences: "tenant/GetTenantPreferences"
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    }
  },
  mounted() {
    if (this.userRole === "Tenant") {
      this.getPreference(this.userId).then(result => {
        if (result.status === 1) {
          if (
            this.tenantPreferences.languages &&
            this.tenantPreferences.languages.length > 0
          ) {
            this.tenantPreferences.languages.map(obj => {
              this.selectedLanguage.push({
                id: obj,
                name: this.langObj[obj]
              });
            });
            this.defaultLanguage = this.tenantPreferences.defaultLanguage;
            this.lightMode = this.tenantPreferences.lightMode;
            this.enableManufacturer = this.tenantPreferences.enableManufacturer;
          }
        }
      });
    }
    this.$store.dispatch("profileUpdate/fetchmeTenant").then(d => {
      this.details.phone = this.userInfo.authentication.phone;
      this.details.name = this.userInfo.authentication.userName;
      this.details.email = this.userInfo.authentication.email;
      this.address.city = this.userInfo.office.address.city;
      this.address.country = this.userInfo.office.address.country;
      this.address.houseNumber = this.userInfo.office.address.houseNumber;
      this.address.state = this.userInfo.office.address.state;
      this.address.street1 = this.userInfo.office.address.street1;
      this.address.street2 = this.userInfo.office.address.street2;
      this.address.zip = this.userInfo.office.address.zip;
    });
  },
  methods: {
    ...mapActions({
      updateProfile: "profileUpdate/updateTenant",
      changePassword: "profileUpdate/UpdatePassword",
      updatePreference: "tenant/updateTenantPreferences",
      getPreference: "tenant/getTenantPreferences"
    }),
    async submit() {
      const userId = this.userInfo._id;
      const data = this.userInfo;

      // get google lat-lng from address object
      try {
        const data = await getReverseGeoCode(
          `${this.address.street1},${this.address.city},${this.address.state},${this.address.country}`
        );
        if (data.data.status === "OK") {
          this.address.location.coordinates = [
            data.data.results[0].geometry.location.lat,
            data.data.results[0].geometry.location.lng
          ];
        }
        console.log("geocoderesult", data);
      } catch (error) {}

      data.office.address = {
        // ...this.userInfo.office.address,
        ...this.address
      };
      data.authentication.userName = this.details.name;
      data.authentication.phone = this.details.phone;
      data.authentication.email = this.details.phone;

      delete data.organization;
      delete data.authorization;
      delete data.authentication.isActive;
      delete data.authentication.otpVerified;
      delete data.authentication.loginAttempts;
      delete data.authentication.forceChangePass;
      delete data.authentication._id;
      delete data.authentication.lockUntil;
      //  delete data.organization.location.type;
      delete data.serviceable;
      delete data.archive;
      delete data._id;
      delete data.bill_to;
      delete data.businessNo;
      delete data.createdAt;
      delete data.updatedAt;
      delete data.idValidation;
      delete data.__v;
      delete data.id;

      await this.updateProfile({ id: userId, data }).then(() => {
        this.$swal({
          title: "Success",
          text: "Profile updated successfully!!",
          type: "success"
        });
      });
    },
    async onSubmit() {
      if (this.newPwd == this.cfmPwd) {
        try {
          const payload = {
            currentPassword: this.oldPwd,
            newPassword: this.newPwd
          };
          await this.changePassword(payload);
          this.$swal({
            title: "Success",
            text: "Password updated successfully",
            type: "success"
          });
        } catch (err) {
          console.log(err);
          this.$swal({
            title: "Error!!",
            text: "Failed",
            type: "error"
          });
        }
      } else {
        this.$swal({
          title: "Error",
          text: "password and confirm password do not match",
          type: "error"
        });
      }
    },
    onSaveLanguage() {
      let languages = [];
      if (this.selectedLanguage && this.selectedLanguage.length > 0) {
        this.selectedLanguage.map(obj => {
          languages.push(obj.id);
        });
      }
      let payload = {
        id: this.userId,
        data: {
          languages: languages,
          defaultLanguage: this.defaultLanguage ? this.defaultLanguage : "en",
          lightMode: this.lightMode,
          enableManufacturer: this.enableManufacturer
        }
      };
      this.updatePreference(payload).then(result => {
        this.$toasted.success("Tenant preferences updated.");
        if (result.status === 1) {
          this.getPreference(this.userId);
        }
      });
    }
  }
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Lato';
  text-decoration: none;
  list-style: none;
}

.pricing-table {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: min(1600px, 100%);
  margin: auto;
}

.pricing-card {
  flex: 1;
  margin: 20px 10px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  color: #2d2d2d;
  transition: 0.3s linear;
}

.pricing-card-header {
  background-color: #727cf5;
  display: inline-block;
  color: #fff;
  padding: 12px 30px;
  border-radius: 0 0 20px 20px;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 600;
  transition: 0.4s linear;
}

.price {
  font-size: 50px;
  color: #727cf5;
  transition: 0.2s linear;
}

.price sup,
.price span {
  font-size: 20px;
  font-weight: 700;
}
.pricing-card li {
  font-size: 13px;
  padding: 8px 0;
  background-color:#F4F4F4;
  text-transform: uppercase;
}

.order-btn {
  padding: 10px 20px;
  width: 80%;
  border-radius: 8px;
}

@media screen and (max-width: 1100px) {
  .pricing-card {
    flex: 50%;
  }
}
p{
    font-size: 13px;
}
.v{
    position: absolute;
width: 90px;
height: 30.5px;
left: 255.5px;
top: 226px;

background: #2DDF89;
}
</style>
